import { PropsWithChildren } from 'react';

import Popover from '@common/ui/Popover';
import { Paper } from '@mui/material';

export type ListFilterProps = PropsWithChildren<{
  trigger: React.ReactElement;
  testId?: string;
  width?: number;
  isOpen: boolean;
  closeDropdown: () => void;
}>;

export default function ListFilter({ trigger, testId, width = 200, isOpen, closeDropdown, children }: ListFilterProps) {
  return (
    <Popover data-testid={testId} trigger={trigger} isOpen={isOpen} onClickOutside={closeDropdown}>
      <Paper sx={{ width }}>{children}</Paper>
    </Popover>
  );
}
